import React from 'react';
import colors from '../../theme/colors';
import ReactSelect from '../ReactSelect';
import StatusDot from '../Status/StatusDot';
import { Flex } from 'rebass';

export type HazardProtectionStatus =
  | 'UNKNOWN'
  | 'NO_HAZARDS'
  | 'UNPROTECTED'
  | 'PROTECTED';

export const hazardProtectionStatusOptions = [
  { value: 'UNKNOWN' as const, label: 'Unknown', color: colors.statusWarning },
  {
    value: 'NO_HAZARDS' as const,
    label: 'No Hazards',
    color: colors.statusSuccess,
  },
  {
    value: 'UNPROTECTED' as const,
    label: 'Unprotected',
    color: colors.statusError,
  },
  {
    value: 'PROTECTED' as const,
    label: 'Protected',
    color: colors.statusSuccess,
  },
] as const;

export const hazardProtectionStatusStyle = (
  status: HazardProtectionStatus
): 'success' | 'warning' | 'error' => {
  switch (status) {
    case 'PROTECTED':
      return 'success';
    case 'NO_HAZARDS':
      return 'success';
    case 'UNKNOWN':
      return 'warning';
    case 'UNPROTECTED':
      return 'error';
  }
};

export const HazardProtectionStatusPicker = ({
  value,
  isMulti,
  isClearable = false,
  onChange,
}: {
  value?: HazardProtectionStatus | HazardProtectionStatus[];
  isMulti?: boolean;
  isClearable?: boolean;
  onChange: (
    value?: HazardProtectionStatus | HazardProtectionStatus[] | undefined
  ) => void;
}) => {
  const selectedValue = isMulti
    ? hazardProtectionStatusOptions.filter((o) =>
        Array.isArray(value) ? value.includes(o.value) : false
      )
    : (hazardProtectionStatusOptions.find((o) => o.value === value) ?? null);

  return (
    <ReactSelect
      placeholder="hazard status"
      isMulti={isMulti}
      isClearable={isClearable}
      isSearchable
      value={selectedValue}
      onChange={(selected: any) => {
        if (isMulti) {
          const values = Array.isArray(selected)
            ? selected.map((s: any) => s.value)
            : [];
          onChange(values.length ? values : undefined);
        } else {
          onChange(selected?.value ?? undefined);
        }
      }}
      options={hazardProtectionStatusOptions}
      formatOptionLabel={(option: any) => (
        <Flex alignItems="center" sx={{ gap: 1 }}>
          <StatusDot status={hazardProtectionStatusStyle(option.value)} />
          {option.label}
        </Flex>
      )}
    />
  );
};
